import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

/**
 * Trunca o texto do elemento host a `maxChars` caracteres (default 70),
 * acrescentando "..." quando corta, e mostra o texto COMPLETO num
 * `matTooltip` apenas quando há truncamento. Pensado para o TÍTULO/nome de
 * arquivos (file rules), onde o nome pode ser longo demais para o layout.
 *
 * Truncamento por CONTAGEM DE CARACTERES (previsível, independe da largura).
 * Para truncamento por largura (CSS ellipsis) use `appOverflowTooltip`.
 *
 * O host precisa ter `matTooltip` aplicado — a diretiva o injeta e controla
 * `message`/`disabled` (mesmo padrão de OverflowTooltipDirective). Como a
 * diretiva escreve o `textContent`, NÃO use interpolação no mesmo elemento;
 * passe o texto via `[appTruncate]` e um sufixo opcional via `truncateSuffix`
 * (ex.: '*' para regra obrigatória).
 *
 * @example
 * <p class="file-title" matTooltip
 *    [appTruncate]="rule.name"
 *    [truncateSuffix]="rule.required ? '*' : ''"></p>
 */
@Directive({
  selector: '[appTruncate]',
})
export class TruncateDirective implements OnChanges {
  @Input('appTruncate') text = '';
  @Input() maxChars = 70;
  @Input() truncateSuffix = '';

  constructor(
    private host: ElementRef<HTMLElement>,
    private tooltip: MatTooltip,
  ) {}

  ngOnChanges(): void {
    const text = this.text ?? '';
    const truncated = text.length > this.maxChars;
    this.host.nativeElement.textContent =
      (truncated ? text.slice(0, this.maxChars) + '...' : text) + (this.truncateSuffix ?? '');
    // Texto completo no tooltip; só habilitado quando de fato truncou.
    this.tooltip.message = text;
    this.tooltip.disabled = !truncated;
  }
}
